import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase, ALLOWED_DOMAIN } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null); // { type, text }

  if (!loading && user) {
    const to = location.state?.from?.pathname || '/';
    return <Navigate to={to} replace />;
  }

  const domainOk = (e) => e.trim().toLowerCase().endsWith('@' + ALLOWED_DOMAIN);

  async function loginPassword(e) {
    e.preventDefault();
    setMsg(null);
    if (!domainOk(email)) return setMsg({ type: 'err', text: `@${ALLOWED_DOMAIN} 이메일만 사용할 수 있습니다.` });
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: pw });
    setBusy(false);
    if (error) setMsg({ type: 'err', text: '로그인 실패: ' + error.message });
  }

  async function magicLink() {
    setMsg(null);
    if (!domainOk(email)) return setMsg({ type: 'err', text: `@${ALLOWED_DOMAIN} 이메일만 사용할 수 있습니다.` });
    setBusy(true);
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { emailRedirectTo: window.location.origin },
    });
    setBusy(false);
    if (error) setMsg({ type: 'err', text: '전송 실패: ' + error.message });
    else setMsg({ type: 'ok', text: '로그인 링크를 이메일로 보냈습니다. 메일함을 확인하세요.' });
  }

  async function google() {
    setMsg(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    });
    if (error) setMsg({ type: 'err', text: 'Google 로그인 오류: ' + error.message });
  }

  return (
    <div className="center">
      <div className="auth-box">
        <img src="/logo-wordmark.png" alt="루나르트" style={{ height: 36, margin: '4px auto 16px', display: 'block' }} />
        <h2>워크스페이스</h2>
        <div className="sub">사내 협업 공간에 로그인하세요</div>

        <form onSubmit={loginPassword}>
          <div className="field">
            <label>회사 이메일</label>
            <input className="inp" type="email" autoComplete="email" placeholder={`name@${ALLOWED_DOMAIN}`}
              value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="field">
            <label>비밀번호</label>
            <input className="inp" type="password" autoComplete="current-password" placeholder="••••••••"
              value={pw} onChange={(e) => setPw(e.target.value)} />
          </div>
          <button className="btn" type="submit" disabled={busy || !email || !pw}>
            {busy ? '처리 중…' : '로그인'}
          </button>
        </form>

        <div className="or">또는</div>
        <button className="btn ghost" onClick={google} disabled={busy} style={{ marginBottom: 9 }}>
          <span className="gicon" /> Google 계정으로 계속
        </button>
        <button className="btn ghost" onClick={magicLink} disabled={busy || !email}>
          ✉️ 매직 링크로 로그인 (비밀번호 없이)
        </button>

        {msg && <div className={`note ${msg.type}`}>{msg.text}</div>}
        <div className="note info">🔒 <span><b>@{ALLOWED_DOMAIN}</b> 도메인만 가입·로그인할 수 있습니다.</span></div>
      </div>
    </div>
  );
}
